<template>
  <div class="dropdown-button" :style="isSession ? 'margin-right: 16px;' : ''">
    <div class="dropdown-icon" @click="toggleDropdown" :class="getClasses" :style="getCustomStyles">
      <!-- <ik-image loading="lazy" :transformation="[{ height: 200, width: 200 }]" src="https://ik.imagekit.io/elysiumone/Official/schedule_y_l6j6ki4.png?ik-sdk-version=javascript-1.4.3&updatedAt=1661420010624" class="tasks--icon" /> -->
      <IconBase icon-name="actions" iconColor="#222" viewBox="0 0 48 48" width="100%" height="100%" strokeWidth="0.3px"><IconTodo /></IconBase>
    </div>
    <Tasks v-if="dropDownOpen" />
  </div>
</template>

<script>
import CloseComponent from "@/mixins/CloseComponent";

import IconBase from "@/components/IconBase";
import IconTodo from "@/components/SVG/IconTodo";

import Tasks from "./Tasks";
/* import { ELYXCentralStore } from "../../../ELYX/ELYXStore";
import ELYXConstants from "../../../ELYX/ELYXConstants"; */

import TasksStore from "./TasksStore.js";

export default {
  name: "TasksButton",

  mixins: [CloseComponent],

  props: {
    isSession: Boolean,
  },
  components: {
    IconBase,
    IconTodo,
    Tasks,
  },
  computed: {
    tasksOpen: () => TasksStore.state.isOpen,

    dropDownOpen() {
      return this.componentOpen; /* from mixin */
    },
    getClasses() {
      let classes = "";
      if (this.isSession) {
        classes = "session-icon" + " ";
      }
      if (this.tasksOpen) {
        classes += "icon--active" + " ";
      }
      return classes;
    },
    getCustomStyles() {
      return "height: 20px; width: 20px; margin-top: 0px;";
    },
  },
  methods: {
    toggleDropdown() {
      if (this.$isMobile) {
        /* if (ELYXCentralStore.state.activeModal?.name !== ELYXConstants.modals.Tasks.name) {
          ELYXCentralStore.methods.setModal(ELYXConstants.modals.Tasks);
        } else {
          ELYXCentralStore.methods.closeModal();
        } */
        TasksStore.methods.toggleIsOpen();
      } else {
        if (!this.componentOpen) {
          window.mixpanel.track("Open Tasks Dropdown");
        }
        TasksStore.methods.toggleIsOpen();
        /* wrapper for mixin */
        /* this.toggleComponent(); */
      }
    },
  },
};
</script>

<style scoped>
@import "./styles/DropdownButton.css";
.tasks--icon {
  width: 21.5px;
  height: 20.5px;
}
.icon--active {
  background-color: #f2f2f2;
}
</style>
